import { render, staticRenderFns } from "./GiftedTokens.vue?vue&type=template&id=b9b019be&scoped=true&"
import script from "./GiftedTokens.vue?vue&type=script&lang=ts&"
export * from "./GiftedTokens.vue?vue&type=script&lang=ts&"
import style0 from "./GiftedTokens.vue?vue&type=style&index=0&id=b9b019be&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9b019be",
  null
  
)

export default component.exports